import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ChargePerson from "./chargePerson";
import DepartmentSelect from "./departmentSelect";
import ServerSelect from "./serverSelect";
import { getDeptById } from "@/api/management/dept";
import { tHallBatchReportSaveOrUpdate } from "@/api/management/report";
import moment from "moment";
export default {
  name: "addOrEdit",
  components: {
    ChargePerson: ChargePerson,
    ServerSelect: ServerSelect,
    DepartmentSelect: DepartmentSelect
  },
  props: [],
  data: function data() {
    return {
      loading: false,
      show: false,
      title: "新建任务",
      type: "add",
      formValidate: {
        reportName: "",
        time: "",
        repet: false,
        repetType: "",
        date: "",
        day: "",
        month: "",
        repetTime: "",
        userIds: [],
        serveId: "",
        cron: "",
        message: "1",
        id: "",
        createMode: 1,
        crowdType: "0"
      },
      ruleValidate: {
        reportName: [{
          required: true,
          message: "填报任务名称不能为空",
          trigger: "blur"
        }, {
          min: 1,
          max: 50,
          message: "长度在 1 到 50 个字符",
          trigger: "blur"
        }],
        time: [{
          required: true,
          message: "执行时间不能为空",
          trigger: "blur"
        }],
        userIds: [{
          required: true,
          message: "请选择人员",
          trigger: "blur"
        }],
        serveId: [{
          required: true,
          message: "请选择服务"
        }],
        repetType: [{
          required: true,
          message: "请选择重复周期",
          trigger: "blur"
        }],
        // repetMethod1: [
        //   {required: true, message: '不能为空', trigger: 'blur'},
        // ],
        day: [{
          required: true,
          message: "不能为空",
          trigger: "blur"
        }],
        date: [{
          required: true,
          message: "不能为空",
          trigger: "blur"
        }],
        repetTime: [{
          required: true,
          message: "不能为空",
          trigger: "blur"
        }],
        crowdType: [{
          required: true,
          message: "请选择人群类型",
          trigger: "blur"
        }]
      },
      personViewText: "",
      serverViewText: "",
      personData: {
        userData: [],
        state: false,
        disabled: false,
        data: []
      },
      userData: {
        userName: "",
        userId: "",
        deptId: "",
        deptName: ""
      },
      bmShow: false,
      //显示部门选择按钮
      userShow: true,
      //任务人群显示
      bmVisible: false //部门选择弹窗

    };
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {},
  methods: {
    autoUserData: function autoUserData(type, data) {
      var _this = this;

      if (type === "add") {
        var _JSON$parse = JSON.parse(localStorage.getItem("userData")),
            deptId = _JSON$parse.deptId,
            userId = _JSON$parse.userId,
            userName = _JSON$parse.userName;

        this.userData.userId = userId;
        this.userData.userName = userName;
        this.userData.deptId = deptId;
        getDeptById(deptId).then(function (_ref) {
          var data = _ref.data;
          _this.userData.deptName = data.data.name;
        }).catch(function () {
          _this.$message.error("获取部门信息失败");
        });
      } else {
        this.userData.userName = data.userName;
        this.userData.deptName = data.deptName;
      }
    },
    dialogShow: function dialogShow(type, data) {
      var _this2 = this;

      this.show = true;
      this.loading = true;
      this.type = type;
      this.title = type === "add" ? "新建任务" : "编辑任务";

      if (type === "edit" && data) {
        this.formValidate.reportName = data.reportName;
        this.formValidate.time = [data.beginTime, data.endTime];
        this.formValidate.id = data.id;
        this.$nextTick(function () {
          _this2.$refs.formValidate.clearValidate();
        });
      } else {
        this.personViewText = "";
        this.serverViewText = "";
        this.$nextTick(function () {
          _this2.$refs.formValidate.resetFields();
        });
      }

      this.autoUserData(type, data);
      setTimeout(function () {
        _this2.loading = false;
      }, 500);
    },
    addUser: function addUser() {
      this.personData.state = true;
    },
    addBm: function addBm() {
      this.bmVisible = true;
    },
    selectServer: function selectServer() {
      this.$refs.serverSelect.dialogShow();
    },
    closePerson: function closePerson(obj) {
      var _this3 = this;

      console.log(obj, "obj");

      if (!obj.mans) {
        this.personData.state = false;
        return;
      }

      for (var i = 0; i < obj.data.length; i++) {
        if (isNaN(obj.data[i])) {
          obj.data.splice(i, 1);
        }
      }

      if (obj.mans.length > 0) {
        this.personViewText = "";
        obj.mans.forEach(function (item, index) {
          if (index != obj.mans.length - 1) {
            _this3.personViewText += "".concat(item.name, ",");
          } else {
            _this3.personViewText += "".concat(item.name);
          }
        });
      } else {
        this.personViewText = "";
      }

      console.log(this.personViewText);

      if (obj.data.length > 0) {
        this.formValidate.userIds = obj.data;
      }

      this.personData.userData = obj.data;
      this.personData.data = obj.mans;
      this.personData.state = false; // this.planpermissionUserSubmit();
    },
    submitForm: function submitForm() {
      var _this4 = this;

      this.$refs.formValidate.validate(function (valid) {
        if (valid) {
          var obj = {};
          obj.beginTime = _this4.formValidate.time[0];
          obj.endTime = _this4.formValidate.time[1];
          obj.reportName = _this4.formValidate.reportName;

          if (_this4.type === "edit") {
            obj.id = _this4.formValidate.id;
          } else {
            obj.deptId = String(_this4.userData.deptId);
            obj.chargeMan = String(_this4.userData.userId);

            _this4.formValidate.userIds.forEach(function (item, index) {
              _this4.formValidate.userIds[index] = String(item);
            });

            obj.serveId = _this4.formValidate.serveId;
            obj.crowdType = _this4.formValidate.crowdType; //有部门则传任务创建方式

            if (_this4.bmShow) {
              obj.createMode = _this4.formValidate.createMode;
              obj.deptIds = _this4.formValidate.userIds;
            } else {
              obj.userIds = _this4.formValidate.userIds;
            }

            if (_this4.formValidate.repet) {
              if (_this4.formValidate.repetType === "day") {
                obj.cron = "".concat(_this4.formValidate.repetTime, " * * ?");
              } else if (_this4.formValidate.repetType === "week") {
                obj.cron = "".concat(_this4.formValidate.repetTime, " ? * ").concat(_this4.formValidate.day);
              } else if (_this4.formValidate.repetType === "month") {
                obj.cron = "".concat(_this4.formValidate.repetTime, " ").concat(_this4.formValidate.date, " * ?");
              } else if (_this4.formValidate.repetType === "year") {
                obj.cron = "".concat(_this4.formValidate.repetTime, " ").concat(_this4.formValidate.date, " ").concat(_this4.formValidate.month, " ?");
              }
            } else {
              obj.cron = null;
            }
          }

          tHallBatchReportSaveOrUpdate(obj, _this4.type).then(function (_ref2) {
            var data = _ref2.data;

            if (data.code == 0) {
              _this4.$message.success("操作成功");

              _this4.handleClose();

              _this4.$emit("onTaskSubmit");
            }
          }).catch(function () {
            _this4.$message.error("操作失败");
          });
        }
      });
    },
    closeServerSelect: function closeServerSelect(obj) {
      this.formValidate.serveId = obj.id;
      this.serverViewText = obj.serveName;
    },
    //人群类型选择
    typeChange: function typeChange(val) {
      if (val == 1) {
        this.bmShow = true;
        this.userShow = true;
      }

      if (val == 0) {
        this.bmShow = false;
        this.userShow = true;
      }

      if (val == 2) {
        this.userShow = false;
        this.bmShow = false;
      }
    },
    visibleClose: function visibleClose() {
      this.bmVisible = false;
    },
    submit: function submit(data) {
      var _this5 = this;

      if (data.names.length > 0) {
        this.personViewText = "";
        data.names.forEach(function (item, index) {
          if (index != data.names.length - 1) {
            _this5.personViewText += "".concat(item, ",");
          } else {
            _this5.personViewText += "".concat(item);
          }
        });
      } else {
        this.personViewText = "";
      } //部门id


      if (data.ids.length > 0) {
        this.formValidate.userIds = data.ids;
      } else {
        this.formValidate.userIds = [];
      }

      this.bmVisible = false;
    },
    handleClose: function handleClose() {
      this.bmShow = false;
      this.show = false;
    }
  },
  watch: {},
  filters: {}
};